import React from 'react';
import { Field } from 'redux-form';
import { AutocompleteInput, BooleanInput, ReferenceInput, SelectInput } from 'react-admin';
import { FormDataConsumer } from 'react-admin';
import { Link } from 'react-router-dom';
import { linkToRecord } from 'ra-core';
import { createStyles, withStyles } from '@material-ui/core/styles';

import HasDynamicPlacement from '../Helpers/HasDynamicPlacement';
import { PlacementModeDropdown } from '../StaticData/PlacementModes';
import StatusIconSmall from '../../../../Common/Icons/StatusSmall';

const styles = createStyles({
  mode: {
    minWidth: 240
  },
  placement: {
    minWidth: 775
  }
});

type Props = {
  classes: any,
  record: any
};

const LinkedPlacementsTab = (props: Props) => (
  <div>
    <FormDataConsumer>
      {({ formData, ...rest }) => HasDynamicPlacement(formData) &&
        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ flex: 1, paddingTop: 20 }}>
            <span style={{ paddingRight: 10 }}>
              <StatusIconSmall enabled={props.record.dynamic_placement_status} />
            </span>
            <Link to={linkToRecord("/placements", props.record.dynamic_placement_code)} target="_blank">
              {props.record.dynamic_placement_name} - {props.record.dynamic_placement_code}
            </Link>
          </div>
          <div style={{ flex: 1 }}>
            <Field name="dynamic_placement_remove" source="dynamic_placement_remove" component={BooleanInput} label="Remove Placement" />
          </div>
        </div>
      }
    </FormDataConsumer>

    <Field name="dynamic_placement" source="dynamic_placement" component={ReferenceInput} label="Linked Placement" reference="helpers/placement_ids" resource="campaign_sites" sort={{ field: 'name', order: 'ASC' }} className={props.classes.placement} allowEmpty>
      <Field name="dynamic_placement" source="dynamic_placement" component={AutocompleteInput} />
    </Field>

    <Field name="dynamic_placement_mode" source="dynamic_placement_mode" component={SelectInput} choices={PlacementModeDropdown} className={props.classes.mode} />
  </div>
);

export default withStyles(styles)(LinkedPlacementsTab);



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Partials/LinkedPlacementsTab.tsx